module.exports = __webpack_public_path__ + "static/rectangle-gradient-e96f62d1a79a3c981a1036519a56058c.png";